module.exports = __webpack_public_path__ + "5c33e55d155844898cddc1b33b3fb7eb.svg";